"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreadcrumbLink = exports.BreadcrumbText = exports.BreadcrumbIcon = exports.Breadcrumbs = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _forwardArrow = _interopRequireDefault(require("@bit/knotchinc.web-react-components.icons.forward-arrow/forwardArrow.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding-left: 10px;\n  display: inline-block;\n  transition: all 0.3s ease;\n  color: white;\n\n  &:first-child {\n    padding-left: 0;\n  }\n\n  &:last-child {\n    ", " {\n      opacity: 1;\n    }\n  }\n\n  &:hover {\n    text-decoration: ", ";\n    cursor: pointer;\n\n    ", " {\n      opacity: 1;\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  opacity: 0.5;\n  transition: all 0.3s ease;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  opacity: 0.5;\n  display: inline-block;\n  background-image: url(", ");\n  background-size: 5px 7px;\n  background-position: center center;\n  background-repeat: no-repeat;\n  margin-right: 10px;\n  width: 6px;\n  height: 8px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  line-height: 70px;\n  margin-left: 35px;\n  font-size: 12px;\n  color: white;\n  letter-spacing: 0.02em;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Breadcrumbs = _styledComponents["default"].div(_templateObject());

exports.Breadcrumbs = Breadcrumbs;

var BreadcrumbIcon = _styledComponents["default"].div(_templateObject2(), _forwardArrow["default"]);

exports.BreadcrumbIcon = BreadcrumbIcon;

var BreadcrumbText = _styledComponents["default"].span(_templateObject3());

exports.BreadcrumbText = BreadcrumbText;

var BreadcrumbLink = _styledComponents["default"].div(_templateObject4(), BreadcrumbText, function (_ref) {
  var noUnderline = _ref.noUnderline;
  return noUnderline ? 'none' : 'underline';
}, BreadcrumbText);

exports.BreadcrumbLink = BreadcrumbLink;

//# sourceMappingURL=styled.js.map